export default {
  BASE_URL: '',
  api: [
    // 销售报表
    {
      name: 'getOrderStatisticV5',
      desc: '销售订单维度报表',
      method: 'GET',
      path: '/statistics/order/getOrderStatistic'
    },
    {
      name: 'getCustomerStatisticV5',
      desc: '销售订单客户维度报表',
      method: 'GET',
      path: '/statistics/order/getCustomerStatistic'
    },
    {
      name: 'getProjectStatisticV5',
      desc: '销售订单项目维度报表',
      method: 'GET',
      path: '/statistics/order/getProjectStatistic'
    },
    {
      name: 'getParentProjectStatisticV5',
      desc: '销售订单项目（父）维度报表',
      method: 'GET',
      path: '/statistics/order/parent/getProjectStatistic'
    },

    // 采购报表
    {
      name: 'getPurchaseStatisticV5',
      desc: '采购订单维度报表',
      method: 'GET',
      path: '/statistics/purchase/getPurchaseStatistic'
    },
    {
      name: 'getSupportStatisticV5',
      desc: '采购供应商维度报表',
      method: 'GET',
      path: '/statistics/purchase/getSupportStatistic'
    },

    // 财务报表
    {
      name: 'financeV5',
      desc: '财务报表统计',
      method: 'GET',
      path: '/statistics/report/getFinanceStatistic'
    },
    // 相关筛选接口
    {
      name: 'getOrderStatusV5',
      desc: '销售状态下拉框',
      method: 'GET',
      path: '/tm/order/getOrderStatus'
    },
    {
      name: 'getPurchaseStatusV5',
      desc: '采购状态下拉框',
      method: 'GET',
      path: '/ph/purchase/getPurchaseStatus'
    },
    {
      name: 'getBillFlagV5',
      desc: '采购订单标识下拉框',
      method: 'GET',
      path: '/ph/purchase/getBillFlag'
    },
    {
      name: 'getProjectListV5',
      desc: '项目下拉列表',
      method: 'GET',
      path: '/crm/project/list'
    },
    // 导出
    {
      name: 'saleExportV5',
      desc: '销售订单订单维度报表--导出',
      method: 'GET',
      path: '/statistics/order/getOrderStatistic/excel'
    },
    {
      name: 'customerExportV5',
      desc: '销售订单客户维度报表--导出',
      method: 'GET',
      path: '/statistics/order/getCustomerStatistic/excel'
    },
    {
      name: 'projectExportV5',
      desc: '销售订单项目维度报表--导出',
      method: 'GET',
      path: '/statistics/order/getProjectStatistic/excel'
    },
    {
      name: 'parentProjectExportV5',
      desc: '销售订单项目（父）维度报表--导出',
      method: 'GET',
      path: '/statistics/order/parent/getProjectStatistic/excel'
    },
    {
      name: 'purchaseExportV5',
      desc: '采购订单维度报表--导出',
      method: 'GET',
      path: '/statistics/purchase/getPurchaseStatistic/excel'
    },
    {
      name: 'supportExportV5',
      desc: '采购供应商维度报表--导出',
      method: 'GET',
      path: '/statistics/purchase/getSupportStatistic/excel'
    },
    {
      name: 'financeExportV5',
      desc: '财务报表导出',
      method: 'GET',
      path: '/statistics/report/export'
    },
    {
      name: 'financeExportInfoV5',
      desc: '财务报表明细导出',
      method: 'GET',
      path: '/statistics/report/exportDetail'
    },
    {
      name: 'getPurchaseStatisticByLinkV5',
      desc: '财务采购订单数量超链接',
      method: 'GET',
      path: '/statistics/report/getPurchaseStatisticByLink'
    },
    {
      name: 'getStatisticsMonthReport',
      desc: '月度报表-列表',
      method: 'GET',
      path: '/statistics/month/report'
    }, // 收付款台账
    {
      name: 'getStatisticsExportBalance',
      desc: '收付款余额表导出',
      method: 'GET',
      path: '/statistics/excel/exportList'
    },
    {
      name: 'getStatisticsExportPur',
      desc: '收付款明细表导出',
      method: 'GET',
      path: '/statistics/excel/exportPur'
    },
    {
      name: 'getStatisticsExportBind',
      desc: '未绑定的收付款表导出',
      method: 'GET',
      path: '/statistics/excel/exportBindPur'
    },
    {
      name: 'getStatisticsExportAll',
      desc: '导出整表',
      method: 'GET',
      path: '/statistics/excel/ledgerList'
    },// 发票台账导出
    {
      name: 'getStatisticsExportFp',
      desc: '发票台账导出',
      method: 'GET',
      path: '/statistics/excel/fpList'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/report/index.js